import React from 'react';


const AlertIcon = ({severity, strokeWhite = false, size = "small", "data-testid": dataTestId = "alert-icon"}) => {
  if (size !== "small" && size !== "large") {
    size = "large"
  }
  if (
    severity !== "maintenance" &&
    severity !== "warning" &&
    severity !== "critical" &&
    severity !== "resolved") {
    severity = "critical"
  }

  const colorSuffix = strokeWhite ? "white" : "default";
  return <img src={`https://assets.cloud.gradientcomfort.com/alert-icons/${severity}-${size}-${colorSuffix}.svg`} alt="" data-testid={dataTestId} />;
}

export default AlertIcon;
